module.exports = __webpack_public_path__ + "static/media/comment-notes.85e5593d.svg";